
import { createSlice } from '@reduxjs/toolkit';
import { getDeletedUsersList } from './ThunkAction';
import { DeletedUserState } from './Types';


const initialState: DeletedUserState = {
  deletedUsersList: [],
  isLoading: false,
  error: null,
};

const deletedUsersSlice = createSlice({
  name: 'deletedUsers',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDeletedUsersList.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getDeletedUsersList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.deletedUsersList = action.payload?.data?.users ?? [];
      })
      .addCase(getDeletedUsersList.rejected, (state, action) => {
  state.isLoading = false;
  state.error = (action.payload as { message: string })?.message ?? 'Something went wrong';
});
  },
});

export default deletedUsersSlice.reducer;